export default __webpack_public_path__ + "static/media/1684_picture.faf6c378.jpg";